export default {"src":"/_next/static/media/9.8af7b634.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};